import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useAtom } from 'jotai';

import { selectedEventAtom, showEventPaneAtom } from '../../../../state/atoms/atoms';

export const EventPaneHeader = () => {
  const [, setshowEventPane] = useAtom(showEventPaneAtom);
  const [selectedEvent, setSelectedEvent] = useAtom(selectedEventAtom);

  return (
    <Stack
      className="event-header-test"
      direction="row"
      spacing={2}
      color="inherit"
      sx={{
        backgroundColor: '#2e2d2e',
        color: '#fff',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '1rem',
      }}
    >
      <Typography variant="h3" color="inherit">
        {selectedEvent?.title ?? 'New Event'}
      </Typography>
      <Tooltip title="Close" arrow placement="top">
        <IconButton
          aria-label="Close"
          onClick={(e) => {
            // Blur the button before closing to prevent aria-hidden focus warning
            e.currentTarget.blur();
            setshowEventPane(false);
            setSelectedEvent(null);
          }}
          color="inherit"
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
